import React, { useState, useEffect } from 'react';
import HeaderComponent from '../components/General/HeaderComponent';
import ProjectList from '../components/Project/List';
import NumberComponent from '../components/Project/NumberComponent';
import ProjectTopBar from '../components/Project/TopBar';
import { getProjects } from '../services/projects';

export default function Projects() {
  const [projectsData, setProjectsData] = useState({
    counts: {
      activeProjects: 0,
      passedProjects: 0,
      finishedProjects: 0,
      projectsCount: 0
    },
    projects: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getProjects();
        if (data) {
          setProjectsData(data);
        }
      } catch (error) {
        console.error('Proje verisi yüklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="w-full h-screen flex justify-center items-center dark:bg-dark-100">
        <img src="/assets/penalogo.svg" alt="Yükleniyor..." width="200" height="200" className="animate-pulse" />
      </div>
    );
  }

  return (
    <div className="w-full dark:bg-dark-100 min-h-[100vh] bg-stone-100 transition duration-300 flex justify-center lg:mt-0 mt-20">
      <div className="container mx-auto">
        <HeaderComponent title={'Projeler'} />
        <NumberComponent 
          number={projectsData.counts.activeProjects} 
          number1={projectsData.counts.passedProjects} 
          number2={projectsData.counts.finishedProjects} 
          number3={projectsData.counts.projectsCount} 
        />
        <ProjectTopBar />
        <ProjectList data={projectsData.projects} />
      </div>
    </div>
  );
}
